import { sectionMetaData } from "./GeneralPage/generalSection";
import { link } from "./link";
import { metaInformation } from "./metaInformation";
import { KontentFilterable } from "./filterable";
import { richText } from "./richText";

export type infoCardGroup = {
  title: string;
  intro: richText;
  cards: infoCard[];
  showHeader: boolean;
} & metaInformation<"infoCardGroup"> &
  sectionMetaData &
  KontentFilterable;

export type infoCard = {
  title: string;
  body: string;
  link: link;
} & metaInformation<"infoCard">;

export function isInfoCardGroup(item: any): item is infoCardGroup {
  return item?.type === "infoCardGroup";
}
